import { ProjectTypeButton } from '@civilgrid/ui/components';
import FeatureFlags, { OrgFeatureFlag } from '~/authorizations/FeatureFlags';
import { capturePosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import { EditorMode, ProjectGeometryType } from '~/common/types';
import { homeMapStore } from '~/pages/homeViewV2/store';

export default function () {
  return (
    <div className="mt-2">
      <div className="mb-4 text-sm font-noto">
        Create a project and tap into CivilGrid's powerful data sources! Instantly generate{' '}
        <span className="font-semibold">
          {' '}
          <a
            target="_blank"
            href="https://civilgrid.help.usepylon.com/articles/5843406317-creating-a-proposal-packet"
            rel="noreferrer noopener"
            className="text-blue-50 underline hover:text-blue-60 font-normal"
          >
            proposal packets
          </a>
          ,{' '}
          <a
            target="_blank"
            href="https://civilgrid.help.usepylon.com/articles/5105685487-full-utility-agency-lists-and-downloads-to-cad-gis"
            rel="noreferrer noopener"
            className="text-blue-50 underline hover:text-blue-60 font-normal"
          >
            access utility agency lists
          </a>
          , conduct records research via our premium{' '}
          <a
            target="_blank"
            href="https://civilgrid.help.usepylon.com/articles/7709282608-2-min-video-guide-to-new-utilities-tab-and-records-request-ui"
            rel="noreferrer noopener"
            className="text-blue-50 underline hover:text-blue-60 font-normal"
          >
            CivilSearch
          </a>{' '}
          offering, and export data effortlessly to GIS/CAD.
        </span>{' '}
        Plus, unlock extensive <span className="font-semibold">Land Rights, Geotechnical, and Environmental</span>{' '}
        datasets to make smarter, faster decisions for your project.
        <br />
        <div className="my-4 rounded border bg-gray-100 p-2 text-center">🚀 Creating a project draft is FREE! 🚀</div>
      </div>
      <div className="flex flex-col space-y-2">
        <ProjectTypeButton
          label={'Linear'}
          description="Use for long projects following a corridor (eg. pipeline, rail, road…)"
          data-testid="new-project-type-linear"
          onClick={() => {
            homeMapStore.setNewProjectMode(true);
            homeMapStore.setEditorMode(EditorMode.DrawLine);
            homeMapStore.setGeometryType(ProjectGeometryType.Linear);
            capturePosthogEvent(POSTHOG_EVENTS.newProjectFlowInitiated, {
              geometry_type: ProjectGeometryType.Linear,
            });
          }}
        />
        <ProjectTypeButton
          label={'Polygon'}
          description="Use for complex shapes that don't follow linear corridors (eg. stations, developments…)"
          data-testid="new-project-type-polygon"
          onClick={() => {
            homeMapStore.setNewProjectMode(true);
            homeMapStore.setEditorMode(EditorMode.DrawPolygon);
            homeMapStore.setGeometryType(ProjectGeometryType.Polygon);
            capturePosthogEvent(POSTHOG_EVENTS.newProjectFlowInitiated, {
              geometry_type: ProjectGeometryType.Polygon,
            });
          }}
        />

        {FeatureFlags.hasOrgFeatureFlag(OrgFeatureFlag.CircleProjects) && (
          <ProjectTypeButton
            label={'Circle'}
            description="Use for circle projects"
            data-testid="new-project-type-circle"
            onClick={() => {
              homeMapStore.setNewProjectMode(true);
              homeMapStore.setEditorMode(EditorMode.DrawCircle);
              homeMapStore.setGeometryType(ProjectGeometryType.Circle);
              capturePosthogEvent(POSTHOG_EVENTS.newProjectFlowInitiated, {
                geometry_type: ProjectGeometryType.Circle,
              });
            }}
          />
        )}
        <ProjectTypeButton
          label={'KMZ'}
          description="Create a project from a KMZ file"
          data-testid="new-project-type-kmz"
          onClick={() => {
            homeMapStore.setGeometryType(ProjectGeometryType.Polygon);
            homeMapStore.setInUploadKMZMode(true);
            capturePosthogEvent(POSTHOG_EVENTS.newProjectFlowInitiated, {
              from_kmz: true,
            });
          }}
        />
      </div>
    </div>
  );
}
